export default __webpack_public_path__ + "static/media/socialmediamarketing.647071e4.png";